module.exports = __webpack_public_path__ + "img/experimentYes.394e60d2.svg";